import { pairwise, filter, first } from 'rxjs/operators';
import { Component, ElementRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { fadeOutAnimation } from 'app/modules/core/animations';
import { AuthService } from './modules/auth/services/auth.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  urls;

  $isAdmin: Observable<boolean>;

  private defaultUrls = {
    back: undefined,
    close: undefined,
    edit: undefined,
    add: undefined,
  };

  private resetUrls() {
    this.urls = Object.assign({}, this.defaultUrls);
  }

  private toTop() {
    this.element.nativeElement.scrollIntoView();
  }

  constructor(private router: Router, private element: ElementRef, private auth: AuthService) {
    const onNavigationEnd = this.router.events.pipe(filter(e => e instanceof NavigationEnd));
    this.auth
      .getAuth()
      .pipe(first())
      .subscribe(a => null);
    this.$isAdmin = this.auth.inRoles('administrator', 'archive-editor');

    this.resetUrls();

    if (!localStorage.getItem('previousUrl')) {
      localStorage.setItem('previousUrl', '');
    }

    if (!localStorage.getItem('projectOverviewUrl')) {
      localStorage.setItem('projectOverviewUrl', '/projects');
    }

    onNavigationEnd.pipe(pairwise()).subscribe(e => {
      if ((<NavigationEnd>e[0]).urlAfterRedirects.indexOf('/page') >= -1) {
        if ((<NavigationEnd>e[0]).urlAfterRedirects.startsWith('/projects?')) {
          localStorage.setItem('projectOverviewUrl', (<NavigationEnd>e[0]).urlAfterRedirects);
        }

        localStorage.setItem('previousUrl', (<NavigationEnd>e[0]).urlAfterRedirects);
      }
    });

    onNavigationEnd.subscribe((e: NavigationEnd) => {
      const url = decodeURIComponent(e.url);
      const prevUrl = decodeURIComponent(localStorage.getItem('previousUrl'));
      const overviewUrl = decodeURIComponent(localStorage.getItem('projectOverviewUrl'));
      this.resetUrls();

      if (url.startsWith('/project/add/') || url.startsWith('/detail/add/')) {
        // EDIT PROJECT
        this.toTop();
        // const test = decodeURIComponent(url);
        // console.log(test);

        this.urls.close = url.replace('/add', '');
      } else if (url === '/project/add') {
        // ADD PROJECT
        this.urls.close = '/projects';
      } else if (url.startsWith('/project/')) {
        // PROJECT DETAILS
        this.urls.back = overviewUrl;
        this.urls.edit = url.replace('/project/', '/project/add/');
      } else if (url.startsWith('/detail/')) {
        this.urls.back = prevUrl.startsWith('/projects/page/') ? prevUrl : '/details/page/1';
        this.urls.edit = url.replace('/detail/', '/detail/add/');
      } else if (url.startsWith('/projects') || url === '/') {
        // HOME
        this.urls.add = '/project/add';
        this.urls.intranet = 'https://intranet.mvrdv.nl';
      }

      if ((<any>window).gtag) {
        (<any>window).gtag('config', 'G-HJ8PPS47MH', { page_path: e.urlAfterRedirects, anonymize_ip: true });
      }
      // console.log(url, prevUrl);
    });
  }
}
